import React, { useMemo, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { confirmPasswordReset } from '../../services/api';
import Header from '../common/Header';

const useQuery = () => {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
};

const ResetPasswordPage = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const [uid, setUid] = useState(query.get('uid') || '');
  const [token, setToken] = useState(query.get('token') || '');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [loading, setLoading] = useState(false);

  const heroBgUrl = `${process.env.PUBLIC_URL}/images/circular_economy_home.png`;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null); setSuccess(null);
    if (!uid || !token) {
      setError('Reset link is missing uid or token. Please use the link from your email.');
      return;
    }
    if (!password || password.length < 8) {
      setError('Password must be at least 8 characters long.');
      return;
    }
    if (password !== password2) {
      setError('Passwords do not match.');
      return;
    }
    try {
      setLoading(true);
      const resp = await confirmPasswordReset({ uid, token, new_password: password });
      setSuccess(resp?.detail || 'Password has been reset. You can now sign in.');
      setTimeout(() => navigate('/login'), 1500);
    } catch (err) {
      setError(err?.response?.data?.detail || err?.message || 'Failed to reset password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100">
      <Header currentView="reset-password" />
      <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className=" flex flex-col lg:flex-row items-center justify-center p-6 border border-cyan-500 bg-cyan-500 rounded-xl shadow">

        <div className="w-full max-w-md bg-cyan-500 p-6 border-cyan- rounded-xl">
         <img src={heroBgUrl} alt="Circular Economy Home" className="max-w-full max-h-full object-cover" />
        </div>

      <div className="w-full max-w-md bg-white p-6 rounded-xl shadow">
        <h2 className="text-2xl font-bold mb-1 text-gray-800">Set a new password</h2>
        <p className="text-sm text-gray-600 mb-4">Paste your reset code or use the link from your email.</p>
        {error && <div className="mb-3 p-2 text-sm rounded bg-red-50 text-red-700 border border-red-200">{error}</div>}
        {success && <div className="mb-3 p-2 text-sm rounded bg-green-50 text-green-700 border border-green-200">{success}</div>}
        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <label className="block text-sm text-gray-700 mb-1">UID</label>
            <input value={uid} onChange={(e)=>setUid(e.target.value)} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="Paste uid from email (dev only)" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Token</label>
            <input value={token} onChange={(e)=>setToken(e.target.value)} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="Paste token from email (dev only)" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">New password</label>
            <input type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="At least 8 characters" />
          </div>
          <div>
            <label className="block text-sm text-gray-700 mb-1">Confirm new password</label>
            <input type="password" value={password2} onChange={(e)=>setPassword2(e.target.value)} className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" placeholder="Repeat password" />
          </div>
          <button type="submit" disabled={loading} className={`w-full py-2 rounded text-white font-medium ${loading ? 'bg-gray-400' : 'bg-cyan-600 hover:bg-cyan-700'}`}>{loading ? 'Resetting…' : 'Reset password'}</button>
        </form>
        <div className="mt-4 text-sm flex justify-between">
          <Link to="/login" className="text-cyan-700 hover:underline">Back to sign in</Link>
          <Link to="/forgot-password" className="text-cyan-700 hover:underline">Request new link</Link>
        </div>
      </div>
      </div>
      </div>
    // </div>
  );
};

export default ResetPasswordPage;
